import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=7c83842e&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83842e",
  null
  
)

export default component.exports